import { render } from "./Discounts.vue?vue&type=template&id=343e928c"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"
script.render = render

export default script